export default "__VITE_ASSET__BnOIPQ24__"